import { jsx as t, jsxs as l } from "react/jsx-runtime";
import { createContext as _, useRef as i, useMemo as h, useEffect as a, useContext as P } from "react";
import { clsx as N } from "../utils/classnames.js";
import { a as b } from "../index.esm-BgWtdyFo.js";
import '../assets/info-popup.css';function u(o) {
  const n = i(null), e = i(null), s = h(() => {
    if (o.footerProps == null) return;
    const { className: c, ...m } = o.footerProps;
    return m;
  }, [o.footerProps]);
  a(() => {
    if (o.open)
      return n.current?.showModal(), () => n.current?.close();
  }, [o.open]), a(() => {
    o.open && e.current != null && (e.current.scrollTop = 0);
  }, [o.open]);
  function p(c) {
    c.stopPropagation(), o.onClose?.(c);
  }
  function d() {
    n.current?.close();
  }
  return /* @__PURE__ */ t(f.Provider, { value: { closePopup: d, dialogRef: n, dialogBodyRef: e }, children: /* @__PURE__ */ t(
    "dialog",
    {
      "data-test": "info-popup",
      className: "info-popup",
      onClose: p,
      onCancel: o.onCancel,
      ref: n,
      children: /* @__PURE__ */ l("article", { className: "info-popup__body", ref: e, children: [
        /* @__PURE__ */ l("header", { className: "info-popup__header", children: [
          o.header,
          (o.showCloseButton ?? !0) && /* @__PURE__ */ l(
            "button",
            {
              type: "button",
              title: "Close",
              className: "info-popup__close-btn info-popup__icon-btn",
              onClick: () => n.current?.close(),
              children: [
                /* @__PURE__ */ t(b, {}),
                /* @__PURE__ */ t("span", { className: "sr-only", children: "Close" })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ t("section", { className: "info-popup__content", children: o.children }),
        o.footer && /* @__PURE__ */ t(
          "footer",
          {
            className: N("info-popup__footer", o.footerProps?.className),
            ...s,
            children: o.footer
          }
        )
      ] })
    }
  ) });
}
u.WithContext = C;
u.Title = y;
u.Subtitle = I;
u.ButtonGroup = x;
u.Button = B;
u.IconButton = g;
const f = _({
  closePopup() {
  },
  /* @type {React.RefObject<HTMLDialogElement|null>} */
  dialogRef: { current: null },
  /* @type {React.RefObject<HTMLElement|null>} */
  dialogBodyRef: { current: null }
});
function C({ children: o }) {
  let n = P(f);
  return typeof o == "function" ? o(n) : o;
}
function y({ className: o, ...n }) {
  return /* @__PURE__ */ t("h2", { className: r("info-popup__title", o), ...n });
}
function I({ className: o, ...n }) {
  return /* @__PURE__ */ t("p", { className: r("info-popup__subtitle", o), ...n });
}
function x({ className: o, ...n }) {
  return /* @__PURE__ */ t("div", { className: r("info-popup__btn-group", o), ...n });
}
function B({ variant: o, className: n, ...e }) {
  return /* @__PURE__ */ t(
    "button",
    {
      type: "button",
      "data-test": "info-popup-btn",
      className: r("info-popup__btn", n),
      "data-variant": o,
      ...e
    }
  );
}
function g({ title: o, className: n, children: e, ...s }) {
  return /* @__PURE__ */ l(
    "button",
    {
      type: "button",
      title: o,
      className: r("info-popup__icon-btn", n),
      ...s,
      children: [
        e,
        /* @__PURE__ */ t("span", { className: "sr-only", children: o })
      ]
    }
  );
}
function r(...o) {
  return o.filter((n) => typeof n == "string" && n != "").join(" ");
}
export {
  u as default
};
